/** Violet gradient. Document with content lines, gentle breathe animation. */

import { type EmblemProps } from './types';

export function LessonPages({ size = 36, className = '' }: EmblemProps) {
  return (
    <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size }}>
      {/* Glow */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        className="absolute inset-0"
        style={{ filter: 'blur(5px)', opacity: 0.3 }}
      >
        <rect x="10" y="4" width="28" height="40" rx="5" fill="url(#f-book-glow)" />
        <defs>
          <linearGradient
            id="f-book-glow"
            x1="24"
            y1="4"
            x2="24"
            y2="44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9B4A" />
            <stop offset="0.55" stopColor="#FF6EB1" />
            <stop offset="1" stopColor="#8A6CF0" />
          </linearGradient>
        </defs>
      </svg>

      {/* Main book */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        className="relative animate-breathe"
      >
        <defs>
          <linearGradient
            id="f-book-grad"
            x1="24"
            y1="4"
            x2="24"
            y2="44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9B4A" />
            <stop offset="0.55" stopColor="#FF6EB1" />
            <stop offset="1" stopColor="#8A6CF0" />
          </linearGradient>
          <linearGradient
            id="f-book-fill"
            x1="24"
            y1="6"
            x2="24"
            y2="42"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9B4A" stopOpacity="0.2" />
            <stop offset="1" stopColor="#8A6CF0" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        {/* Book body */}
        <rect
          x="10"
          y="6"
          width="28"
          height="36"
          rx="4"
          fill="url(#f-book-fill)"
          stroke="url(#f-book-grad)"
          strokeWidth="1.5"
        />
        {/* Spine accent */}
        <line
          x1="10"
          y1="10"
          x2="10"
          y2="38"
          stroke="url(#f-book-grad)"
          strokeWidth="2"
          strokeLinecap="round"
          opacity="0.5"
        />
        {/* Content lines */}
        <rect x="16" y="15" width="16" height="2" rx="1" fill="url(#f-book-grad)" opacity="0.6" />
        <rect x="16" y="21" width="12" height="2" rx="1" fill="url(#f-book-grad)" opacity="0.4" />
        <rect x="16" y="27" width="14" height="2" rx="1" fill="url(#f-book-grad)" opacity="0.3" />
        <rect x="16" y="33" width="10" height="2" rx="1" fill="url(#f-book-grad)" opacity="0.2" />
      </svg>
    </div>
  );
}
